/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, OnInit } from '@angular/core';
import { BootstrapService } from '@services/bootstrap/bootstrap.service';
import { ProcessAdjusterService } from './custom/services/process-adjuster/process-adjuster.service';
import { AnalyticsService } from '@core/services/analytics/analytics.service';
import { PositionService } from '@core/services/position/position.service';
import {
  AnalyticsEventDataModel,
  AnalyticsOutcomeEventModel
} from '@core/models';
import { truncateText } from '@core/utils';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    bootstrapService: BootstrapService,
    processAdjusterService: ProcessAdjusterService,
    private analyticsService: AnalyticsService,
    private positionService: PositionService
  ) {
    bootstrapService.bootstrap();
    processAdjusterService.init();
  }

  ngOnInit() {
    this.pushAnalytics();
  }

  private pushAnalytics(): void {
    this.analyticsService.getEventDataStream().subscribe(res => {
      try {
        (window as any).dataLayer.push(this.enrichAnalytic(res));
      } catch (_) {}
    });
  }

  private enrichAnalytic(event: AnalyticsEventDataModel): any {
    const position = this.positionService.getPosition();

    if (!position || !position.data) {
      return event.event;
    }

    if (event.name === 'request_outcome') {
      (event.event as AnalyticsOutcomeEventModel).request.description =
        // eslint-disable-next-line @typescript-eslint/dot-notation
        truncateText(position.data['businessKey']['bankProductName'], {
          maxLength: 100
        });
    }

    return {
      ...event.event,
      card: {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        scheme: position.data['businessKey']['circuit'],
        // eslint-disable-next-line @typescript-eslint/dot-notation
        abi: position.data['businessKey']['abi'],
        // eslint-disable-next-line @typescript-eslint/dot-notation
        affinity: position.data['businessKey']['affinity'],
        // eslint-disable-next-line @typescript-eslint/dot-notation
        cpp: position.data['businessKey']['cpp']
      },
      // eslint-disable-next-line @typescript-eslint/dot-notation
      ['campaign_id']: position.data['businessKey']['campaignId'],
      // eslint-disable-next-line @typescript-eslint/dot-notation
      ['offer_id']: position.data['businessKey']['encodedMemberIdHashed'],
      // eslint-disable-next-line @typescript-eslint/dot-notation
      ['offer_id_encoded']: position.data['businessKey']['encodedMemberId']
    };
  }
}
